module.exports = __webpack_public_path__ + "img/settings-fill.27091ec7.svg";